import { useAds } from 'hooks/useAds'
import { AdSizeCode, AdZone } from 'models/Ads'
import React, { useEffect, useMemo } from 'react'
import { getImageUrl } from 'utils/imageUtils';

function pickAsset(zone: AdZone, size: AdSizeCode): string | null {
    const assets = zone.banner?.assets ?? []
    const get = (s: AdSizeCode) => {
        let url = assets.find(a => a.sizeCode === s)?.imageUrl;
        return url ? getImageUrl(url) + '?rand=' + Date.now() : null;
    };

    if (size === AdSizeCode.LG) return get(AdSizeCode.LG) || get(AdSizeCode.MD) || get(AdSizeCode.SM)
    if (size === AdSizeCode.MD) return get(AdSizeCode.MD) || get(AdSizeCode.LG) || get(AdSizeCode.SM)
    return get(AdSizeCode.SM) || get(AdSizeCode.MD) || get(AdSizeCode.LG)
}

export default function AdSlot({
    zone,
    className,
    style
}: {
    zone: string
    className?: string
    style?: React.CSSProperties
}) {
    const { prefetch, getZone } = useAds()

    useEffect(() => {
        prefetch([zone])
    }, [prefetch, zone])

    const z = getZone(zone)

    const isDisplayable = !!(z?.banner && z.banner.isActive && (z.banner.assets?.length ?? 0) > 0)

    const lg = useMemo(() => (z ? pickAsset(z, AdSizeCode.LG) : null), [z])
    const md = useMemo(() => (z ? pickAsset(z, AdSizeCode.MD) : null), [z])
    const sm = useMemo(() => (z ? pickAsset(z, AdSizeCode.SM) : null), [z])

    if (!z || !isDisplayable || (!lg && !md && !sm)) return null

    const picture = (
        <picture className={className} style={style}>
            <source media='(min-width: 1000px)' srcSet={lg ?? md ?? sm ?? undefined} />
            <source media='(min-width: 500px)' srcSet={md ?? lg ?? sm ?? undefined} />
            <img
                src={sm ?? md ?? lg ?? undefined}
                style={{ width: '100%', height: 'auto', display: 'block' }}
                loading='lazy'
            />
        </picture>
    )

    return picture;
}
